import { ACTIONS as logoutActions } from 'actions/logout';
import RestReducer, { errors } from 'redux-rest-reducer';

export default RestReducer({
  FLUSH_ACTIONS: [logoutActions.POST_SUCCESS, errors[401]],
});
